var _style, _g, _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.4 432.6",
    style: {
      enableBackground: "new 0 0 512.4 432.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EDB899;}\n\t.st1{fill:#009365;}\n\t.st2{fill:#ECB348;}\n\t.st3{fill:#604674;}\n\t.st4{fill:#4D2D5C;}\n\t.st5{fill:#2E263E;}\n\t.st6{fill:#EFB999;}\n\t.st7{fill:#D79B7C;}\n\t.st8{fill:#622E1B;}\n\t.st9{fill:#382626;}\n\t.st10{fill:#CF9478;}\n\t.st11{clip-path:url(#SVGID_00000119813889783948467620000001244819791430251663_);}\n\t.st12{fill:#EBDFD6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20020",
    className: "st0",
    d: "M78.2,150.7L78.2,150.7c1.2,10.1,10.3,17.3,20.4,16.2l103.6-1 c11.6-1.4,19.9-11.9,18.6-23.5c-1.4-11.6-11.9-19.9-23.5-18.6c-0.3,0-0.7,0.1-1,0.1l-102,6.4C84.3,131.5,77.1,140.6,78.2,150.7 L78.2,150.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20021",
    className: "st1",
    d: "M350.4,424.6l64.2-136.1l-44.3-87.1l-111.5,47L350.4,424.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20022",
    className: "st2",
    d: "M252.5,252.7c0,0,18.8,7.4,75.9-16.6c40.3-17,49.7-32,49.7-32l-14.3-100.7 c-3.7-23.1-19.9-34.9-42.3-28.4l-91.6,26.7c-21.6,6.4-29.8,24.2-21.9,45.3L252.5,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20023",
    className: "st3",
    d: "M285.8,121.9c12.1-5.2,18.4-18.6,14.7-31.3c-0.1-0.2-0.4-0.4-0.7-0.4 c-0.2,0.1-0.4,0.4-0.3,0.7c3.9,13.1-3.5,26.9-16.6,30.9c-6.3,1.9-13.1,1.2-18.9-1.9c-5.8-3.1-10.1-8.4-12-14.7 c-0.1-0.2-0.4-0.4-0.6-0.3c-0.2,0.1-0.4,0.4-0.3,0.6c4.1,13.7,18.5,21.5,32.3,17.3l0,0C284.1,122.5,284.9,122.3,285.8,121.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20024",
    className: "st4",
    d: "M387.6,241.2c0.9-0.3,1.8-0.8,2.7-1.3c0.2-0.1,0.3-0.4,0.2-0.7c-0.1-0.2-0.4-0.3-0.7-0.2 l0,0c-0.1,0.1-11.4,6.4-22.6,3.1c-6.5-1.9-11.8-6.6-15.6-14c-0.1-0.2-0.4-0.3-0.7-0.2c-0.2,0.1-0.3,0.4-0.2,0.7 c4.1,7.6,9.5,12.5,16.3,14.5C375.1,245.5,383.4,242.8,387.6,241.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20025",
    className: "st4",
    d: "M331,266.1c0.2,0,0.3-0.3,0.3-0.5l-4.9-18.6c-0.1-0.7-0.8-1-1.4-0.9c0,0,0,0-0.1,0l-10,3.3 c-0.6,0.2-1,0.8-0.8,1.4c0,0.1,0.1,0.1,0.1,0.2l4.8,8.3c0.1,0.2,0.4,0.3,0.6,0.2c0.2-0.1,0.3-0.4,0.2-0.6l-4.8-8.3 c-0.1-0.1,0-0.3,0.1-0.4l0,0l10-3.3c0.1-0.1,0.3,0,0.4,0.2l0,0l4.9,18.6C330.4,266,330.7,266.1,331,266.1 C330.9,266.1,331,266.1,331,266.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20026",
    className: "st4",
    d: "M274.5,277L274.5,277c14.2-8.9,9.6-27.2,9.5-27.3c0-0.2-0.3-0.4-0.5-0.4 c-0.2,0-0.4,0.3-0.4,0.5l0,0c0,0.2,4.5,17.8-9.1,26.3c-0.2,0.1-0.2,0.4-0.2,0.6C274.1,277,274.3,277,274.5,277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20027",
    className: "st2",
    d: "M184.2,173l-13-51l29.6-7.6c25.9-6.6,52.1,9,58.7,34.9c0.6,2.4-0.8,4.8-3.2,5.4L184.2,173z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20028",
    className: "st3",
    d: "M180.2,133.7c0.1,0.2,0.4,0.2,0.7,0.1c0.2-0.2,0.3-0.3,0.2-0.6l-3.2-11.8 c0-0.2-0.4-0.4-0.6-0.4c-0.2,0-0.4,0.4-0.4,0.6l0,0l3.2,11.8C180.1,133.6,180.1,133.7,180.2,133.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20029",
    className: "st3",
    d: "M233.9,209.6c0.2-0.1,0.3-0.4,0.3-0.6l0,0l-17.5-41.6c-0.1-0.2-0.4-0.3-0.7-0.2 s-0.3,0.4-0.3,0.6l17.5,41.6C233.4,209.6,233.6,209.7,233.9,209.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20030",
    className: "st0",
    d: "M28.6,53.7L28.6,53.7c-5.2,3.8-6,11.8-1.9,18.2l53.1,84.4c7,9.8,19.5,12.9,27.7,6.9 c8.2-6,9.1-18.8,2-28.5L46.4,57.4C41.5,51.5,33.8,49.9,28.6,53.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20031",
    className: "st0",
    d: "M47.5,64.4c-0.1-2.7-0.3-5.5-0.8-8.2c-0.4-2.6-1.1-5.3-1.9-7.9c-0.8-2.5-1.9-5.1-3.3-7.5 c-1.4-2.3-3.1-4.5-5.2-6.3c-0.6-0.5-1.5-0.5-2,0.1c-0.4,0.5-0.4,1.1-0.1,1.6l0.1,0.1c2.5,3.9,3.3,8.5,3.2,13c0,2.3-0.1,4.6-0.5,6.8 c-0.3,2.2-0.7,4.4-1.4,6.5c-1,3.2,0.7,6.5,4,7.5c3.2,1,6.5-0.7,7.5-4c0.2-0.6,0.3-1.3,0.2-1.8L47.5,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20032",
    className: "st0",
    d: "M34.2,66.5c-0.8-2.9-1.9-5.9-2.9-8.8c-1.1-2.9-2.3-5.9-3.5-8.8c-2.4-5.8-5.5-11.2-9.3-16.2 l-0.1,0c-0.7-0.8-0.5-2,0.3-2.7c0.7-0.5,1.7-0.5,2.4,0c5.1,4.5,9.5,9.5,13.3,15.2c2,2.7,3.7,5.5,5.5,8.4c1.7,2.8,3.4,5.6,5.1,8.8 c1.5,2.9,0.4,6.5-2.6,8c-2.9,1.5-6.5,0.4-8-2.6C34.5,67.3,34.3,67,34.2,66.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20033",
    className: "st0",
    d: "M35.3,79.8c-2.1-1.9-4.5-3.9-6.7-5.7c-2.3-1.8-4.6-3.7-7-5.6c-4.6-3.6-9.6-7-14.6-10.1l0,0 c-0.9-0.6-1.2-1.7-0.7-2.6c0.5-0.8,1.4-1.1,2.3-0.9c5.9,2,11.6,4.3,17.1,6.9c2.8,1.3,5.6,2.6,8.3,4.1c2.7,1.4,5.4,2.8,8.2,4.4 c2.9,1.6,3.8,5.2,2.2,8.1c-1.6,2.9-5.2,3.8-8.1,2.2C36,80.4,35.7,80,35.3,79.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20034",
    className: "st0",
    d: "M26.1,66.9c-1.3-1.6-2.6-3.3-4-4.9c-1.5-1.6-3-3.1-4.7-4.6c-3.3-3-6.9-5.6-10.7-7.8l-0.1,0 c-1-0.5-1.2-1.7-0.8-2.6c0.4-0.7,1.3-1.2,2.1-0.9c4.8,1.1,9.3,2.7,13.8,4.8c2.2,1.1,4.4,2.2,6.5,3.4c2.2,1.3,4.3,2.7,6.3,4.2 l0.1,0.1c2.6,2,3.1,5.8,1.2,8.4c-2,2.6-5.8,3.1-8.4,1.2C26.9,67.8,26.4,67.4,26.1,66.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20035",
    className: "st0",
    d: "M31.2,62.5c-1.7-2.1-3.4-4.3-5.2-6.4c-1.8-2.1-3.6-4.1-5.4-6.2s-3.7-4-5.7-5.9 c-1.9-1.8-3.9-3.6-6.2-5.1l-0.1,0c-0.9-0.6-1.1-1.8-0.5-2.7c0.6-0.8,1.5-1,2.3-0.8c2.7,1,5.3,2.4,7.9,3.9c2.5,1.5,4.9,3,7.3,4.6 c2.3,1.6,4.8,3.2,7.1,5c2.3,1.7,4.6,3.4,6.9,5.2l0,0c2.5,2.1,2.9,5.8,0.8,8.4c-2,2.5-5.7,2.9-8.2,0.9 C31.9,63.2,31.4,62.8,31.2,62.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20037",
    className: "st2",
    d: "M365,149.9l27.9-44.7l-32-19.9c-19.2-11.9-44.7-6.1-56.6,13.1c-3.3,5.5-1.8,12.6,3.7,16 L365,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20038",
    className: "st3",
    d: "M357.9,145.5c0.1-0.1,0.2-0.2,0.3-0.2l26.6-42.1c0.2-0.3,0.1-0.5-0.2-0.7s-0.5-0.1-0.7,0.1 l-26.6,42.1c-0.2,0.3-0.1,0.6,0.2,0.7C357.6,145.6,357.8,145.6,357.9,145.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20039",
    className: "st3",
    d: "M365.2,150.4l11.8-17.9c0.2-0.3,0.1-0.6-0.1-0.7c-0.2-0.1-0.6-0.1-0.7,0.1l0,0L365,148.9 l-19.6-12.2c-0.3-0.2-0.6-0.1-0.7,0.2c-0.2,0.3-0.1,0.6,0.2,0.7L365.2,150.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20041",
    className: "st5",
    d: "M222.4,22.4c0,0-10.4,15.2,3.3,32.7c10.1-7,14.7-27.3,14.6-27.9 C240,26.7,222.4,22.4,222.4,22.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20042",
    className: "st6",
    d: "M281.9,117.2L281.9,117.2c9.8-3.1,15.3-13.6,12.2-23.4l0,0l-15.8-50.2 c-0.4-1.4-1.9-2.1-3.2-1.7l-30.7,9.7c-1.4,0.4-2.1,1.9-1.7,3.2l15.9,50.2C261.6,114.9,272,120.3,281.9,117.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20043",
    className: "st7",
    d: "M282.6,57.5l-5.1-16.8c-2.9-9.7-13.1-15.2-22.8-12.3l0,0c-9.7,2.9-16.2,13.8-13.4,23.5 l16.8,51.8l24.6-46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20044",
    className: "st6",
    d: "M255.9,88.8L255.9,88.8c16-1.2,28-15,26.9-31l0,0L281.4,39c-1.2-15.9-15.1-28-31-26.8 s-28,15-26.9,31l1.4,18.7C226,77.9,239.8,89.9,255.9,88.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20045",
    className: "st5",
    d: "M288.3,75.2c-0.8-0.7,13.7-8.7,12.8-32.3c-0.5-14.1-7.4-23.5-14.8-23.7 c-13.9-27.6-64.8-11.9-66.6-9.9c-1.8,1.9,0.3,28.3,16.4,29.3c16,0.9,34.6-6.1,34.6-6.1s6.2-3.6,8.9,1.6c2.8,5.2-1,9.8-1,9.8 L288.3,75.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20046",
    className: "st6",
    d: "M274.1,56.2c2.4,4.1,7.7,5.4,11.7,3c4.1-2.4,5.4-7.7,3-11.7s-7.7-5.4-11.6-3 C273,46.9,271.7,52.1,274.1,56.2C274,56.2,274.1,56.2,274.1,56.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20047",
    className: "st8",
    d: "M258.8,69.9c0.2-0.4,0.1-0.9-0.4-1.2c-0.2-0.1-0.5-0.1-0.7,0c-3.2,1.3-6.6,2.3-10.1,2.8 c-3.4,0.4-6.7,0.5-10.1-0.1c-0.2-0.1-0.4,0.1-0.4,0.3c0,0.1,0,0.2,0,0.3c1.4,2,5.5,7.1,11.6,6.3C254.2,77.5,257.4,72.8,258.8,69.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20048",
    className: "st9",
    d: "M233,53.6c0.1,1.3,1.2,2.2,2.6,2.2c1.3-0.1,2.2-1.2,2.2-2.6c-0.1-1.3-1.2-2.2-2.6-2.2 C233.8,51.1,232.9,52.2,233,53.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20049",
    className: "st9",
    d: "M255.3,51.2c0.1,1.3,1.2,2.2,2.6,2.2c1.3-0.1,2.2-1.2,2.2-2.6c-0.1-1.3-1.2-2.2-2.5-2.2 C256.3,48.8,255.3,49.8,255.3,51.2L255.3,51.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20050",
    className: "st10",
    d: "M246.9,65.4c0.3-0.1,0.5-0.5,0.4-0.8c-0.1-0.3-0.5-0.5-0.8-0.4c-1.3,0.4-2.8,0.1-3.7-1.1 c-0.9-1.1-1-2.7-0.2-3.9c0.2-0.3,0.1-0.7-0.1-0.9c-0.3-0.2-0.7-0.1-0.9,0.1c0,0,0,0,0,0.1c-1.1,1.6-1.1,3.9,0.2,5.4 C242.9,65.4,245,66,246.9,65.4L246.9,65.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20051",
    className: "st5",
    d: "M263.4,48.3L263.4,48.3c0.3-0.1,0.5-0.5,0.3-0.7c0,0-2-4.7-8.3-4.3 c-0.3,0.1-0.5,0.4-0.5,0.7c0,0.2,0.3,0.5,0.6,0.5c5.3-0.4,7,3.4,7.1,3.5C262.8,48.3,263.2,48.5,263.4,48.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20052",
    className: "st5",
    d: "M241.3,50.6L241.3,50.6c0.4-0.2,0.5-0.5,0.3-0.9c0,0-2.5-4.5-8.6-3.6 c-0.3,0.1-0.5,0.4-0.4,0.7c0,0.3,0.4,0.5,0.6,0.5c5.3-0.8,7.3,2.8,7.4,2.9C240.8,50.6,241,50.7,241.3,50.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.5,165.1L449.5,165.1c-5.2,8.2-16.1,10.5-24.2,5.3l-95.2-47.4c-9.4-6-12.1-18.5-6.1-27.9l0,0 c6.2-9.7,19.3-12.2,28.7-5.5l91.5,51.3C452.4,146.1,454.7,157,449.5,165.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.4,41L475.4,41c-6-1.3-12.2,3.1-14.3,10.1l-35.4,98.6c-2.5,11.2,3.1,22.1,12.6,24.2h0 c9.5,2.1,19.2-5.3,21.7-16.6l24-101.4C485.1,48.9,481.4,42.3,475.4,41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000164475294313465883160000008924679765065371273_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000031911789652814889600000014137093062174985605_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000155866357941115798330000009483891586149740170_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M479.5,60.2c2.9-0.5,5.2-1.2,7.6-2c2.4-0.8,4.8-1.8,7.1-3c2.3-1.2,4.5-2.5,6.5-4.2c2-1.7,3.8-3.6,5.1-5.8 c0.4-0.6,0.2-1.5-0.5-1.9c-0.5-0.3-1.2-0.2-1.6,0.1l-0.1,0.1c-3.3,2.9-7.5,4.3-11.8,5c-2.1,0.4-4.3,0.5-6.5,0.6 c-2.1,0-4.5,0-6.3-0.3c-3.1-0.5-6,1.7-6.5,4.8c-0.5,3.1,1.7,6,4.8,6.5c0.6,0.1,1.2,0.1,1.8,0L479.5,60.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000067233436908625940720000017009294706593754549_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000013179928591700258030000005796220401440303778_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000033342409618286856350000001456972243050506382_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.5,47.9c2.6-1.2,5.3-2.6,7.9-4.1c2.6-1.5,5.2-3,7.8-4.6c5-3.3,9.9-6.8,13.9-11.2l0-0.1 c0.7-0.8,1.9-0.8,2.6-0.1c0.7,0.6,0.8,1.6,0.3,2.3c-3.3,5.6-7.7,10.4-12.2,14.9c-2.3,2.2-4.6,4.4-7.1,6.5 c-2.4,2.1-4.8,4.1-7.5,6.1c-2.5,1.9-6.1,1.4-7.9-1.1c-1.9-2.5-1.4-6.1,1.1-7.9C474.8,48.3,475.2,48.1,475.5,47.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000178171261902917582570000009673387427112879801_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000057114023631450849530000013225387639540875706_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.2,51.1c1.5-2.3,3-4.8,4.4-7.2c1.4-2.4,2.8-4.9,4.2-7.4c2.7-5,5.2-10.1,7.3-15.3l0,0 c0.4-1,1.5-1.4,2.4-1c0.8,0.3,1.3,1.2,1.1,2c-0.9,5.8-2.3,11.5-3.9,17.2c-0.8,2.8-1.7,5.6-2.6,8.4c-0.9,2.8-1.8,5.5-2.9,8.4 c-1.1,2.9-4.3,4.4-7.3,3.4c-2.9-1.1-4.4-4.3-3.4-7.3C462.8,51.8,463,51.4,463.2,51.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000098214330890044251150000016468090626255520906_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000016045054943442714940000012290616269441547711_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M474,40.4c1.3-1.3,2.7-3,4-4.6c1.3-1.6,2.5-3.4,3.6-5.1c2.3-3.5,4.3-7.3,5.7-11.3l0-0.1 c0.3-1,1.4-1.5,2.4-1.1c0.8,0.3,1.3,1.1,1.2,1.9c-0.3,4.6-1.2,9.2-2.5,13.7c-0.7,2.2-1.4,4.4-2.3,6.6c-0.9,2.2-1.8,4.3-3,6.6 l-0.1,0.1c-1.5,2.8-4.9,3.8-7.7,2.4c-2.8-1.5-3.8-4.9-2.4-7.7C473.2,41.2,473.6,40.8,474,40.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000165234519566633579590000000542061103315991976_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000049197255813796876320000018181607005704937130_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.9,44.5c1.7-1.8,3.5-3.9,5.2-5.8c1.7-2,3.4-4,5-6.1c1.6-2,3.2-4.1,4.7-6.3c1.5-2.1,2.9-4.3,3.9-6.5 l0-0.1c0.4-0.9,1.5-1.3,2.5-0.9c0.8,0.4,1.2,1.2,1,2c-0.6,2.8-1.5,5.4-2.5,8c-1,2.6-2.1,5.1-3.2,7.6c-1.2,2.5-2.4,4.9-3.6,7.4 c-1.3,2.4-2.5,4.8-3.9,7.3l0,0c-1.5,2.7-5,3.7-7.7,2.1c-2.7-1.5-3.7-5-2.1-7.7C478.3,45.2,478.6,44.8,478.9,44.5z"
  })))))), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 435.3,
    cy: 155.9,
    r: 17.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5329",
    transform: "translate(218.996 300.597)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M36.9-231.1c-2.7,1-5.4,1.7-8.3,2.1c-2.8,0.4-5.6,0.4-8.4,0.1c-0.6-0.1-1.2,0.4-1.2,1 c0,0.3,0,0.6,0.3,0.8c1.9,2.3,5.5,5.5,10.6,4.8c4.3-0.6,7.2-3.8,9-6.5c0.4-0.7,0.3-1.7-0.5-2.2c-0.1,0-0.3-0.2-0.4-0.2 C37.6-231.3,37.3-231.2,36.9-231.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115503848447432389770000017334414821975799706_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5328",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000115503848447432389770000017334414821975799706_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20053",
    className: "st12",
    d: "M20.2-230.4c0.3,2.6,4.2,4.2,8.7,3.7c4.4-0.5,7.9-3,7.5-5.5c-0.4-2.5-4.2-4.2-8.7-3.7 C23.3-235.4,19.9-232.9,20.2-230.4"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration5);
export default __webpack_public_path__ + "static/media/illustration_5.3829e91f09d0335f4ca31dcbd70925d9.svg";
export { ForwardRef as ReactComponent };